<template>
    <div class="input-item">
        <input
            v-bind="$attrs"
            type="checkbox"
            :id="id"
            :checked="modelValue"
            @change="$emit('update:modelValue', handleInputChange($event))"
            class="input-item__checkbox"
        />

        <label
            v-if="label"
            class="input-item__checkbox__label"
            :for="id"
            :class="{ 'checked': modelValue }"
        >
            {{ label }}
        </label>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue'

    export default defineComponent({
        props: {
            label: {
                type: String,
                default: ''
            },
            modelValue: {
                type: Boolean,
                default: false
            }
        },
        setup() {
            const handleInputChange = (event: Event) => (event.target as HTMLInputElement).checked
            const id = (Math.random() + 1).toString(36).substring(7)

            return { id, handleInputChange }
        }
    })
</script>
